import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { amsterdamNyConfig } from "./data";

export default function AmsterdamNYPage() {
  return <CityPageTemplate config={amsterdamNyConfig} />;
}